export default __webpack_public_path__ + "static/media/Boots of the Savage Slaughter.84204402.jpg";